import { memo, type ReactNode, useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";

// Chart.js描画キャンバスをラップし、wheel操作を上位へ中継する。
export const BitrateChartCanvas = memo(function BitrateChartCanvas(props: {
  data: any;
  options: any;
  onWheel: (e: WheelEvent) => void;
  setChartRef: (chart: any) => void;
  children?: ReactNode;
}) {
  const { data, options, onWheel, setChartRef, children } = props;
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handler = (e: WheelEvent) => {
      onWheel(e);
    };

    // wheel側でpreventDefaultするため、passive:falseかつcaptureで先に捕捉する。
    el.addEventListener("wheel", handler, { passive: false, capture: true });
    return () => {
      el.removeEventListener("wheel", handler, { capture: true } as any);
    };
  }, [onWheel]);

  return (
    <div className="bpslogChart" ref={containerRef}>
      {children}
      <Line ref={setChartRef} data={data} options={options} />
    </div>
  );
});
